import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

/**
 * The "answers can be wrong" line under the chat box. Shared by the
 * conversation page and the Teammate page so both read the same (SB-3978).
 * It binds a fixed translation key with no params, so nothing user-written
 * reaches `[innerHTML]`.
 */
@Component({
  selector: 'squadbox-chat-disclaimer',
  imports: [TranslateModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div
      class="
        text-center
        typo-caption tablet-landscape:typo-p3
        text-neutral-500 tablet-landscape:text-neutral-500
      "
      [innerHTML]="
        (short() ? 'CHAT.DISCLAIMER_SHORT' : 'CHAT.DISCLAIMER_LONG') | translate
      "
    ></div>
  `,
})
export class ChatDisclaimerComponent {
  /** Shows the short wording (mobile, or beside the document viewer). */
  public readonly short = input.required<boolean>();
}
